import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70da0f5c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70da0f5c')) {
      api.createRecord('70da0f5c', component.options)
    } else {
      api.reload('70da0f5c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70da0f5c&", function () {
      api.rerender('70da0f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/store/menus/index.vue"
export default component.exports